import $ from 'jquery';
import LoginSignup from '@shared/modal-login-signup';
import { T_ } from '@shared/translation';
import {
  eventName,
  backToSignupSourcePage,
  isLoginSignup,
  onFreemarket,
  onAffiliatesHiremePage,
  hideConfirmPassword,
  onContest,
  redirectToPcpAfterEmployerSignup,
  redirectToGotoUrl,
  gotoUrl,
  showSignup,
  showLogin,
  preFillSignupForm,
  isLocalProject,
  project_id,
  projectCollaborationInvitationToken,
  signupSkipFunnel,
  teamsSignUp,
  contestCollaborationInvitationToken,
  emailAddress,
  threadId,
} from 'server-data/login-signup';
import '@shared/facebook-connect';

/**
 * This module contains the logic to initialise the login/signup modal that is
 * contained in `@shared/modal-login-signup`.
 */

// set page as sign up source page for future redirection back
// If no local storage supported, we will ignore this redirection
if ('sessionStorage' in window && backToSignupSourcePage) {
  sessionStorage.setItem('signupSourcePage', window.location.href);
}

let loginOptions;
let signupOptions;
let loginClbk = false;
let employerSignupClbk = false;
let workerSignupClbk = false;

if (!onFreemarket) {
  loginOptions = { isLoginSignup };
  signupOptions = { isLoginSignup, teamsSignUp };

  if (hideConfirmPassword) {
    signupOptions.hideConfirmPassword = true;
  }
} else {
  loginOptions = {
    title: T_('Login to Freemarket.com'),
    hideFacebook: true,
    hideLookingFor: true,
    isLoginSignup,
  };

  signupOptions = {
    loginTitle: T_('Login to Freemarket.com'),
    hideFacebook: true,
    hideLookingFor: true,
    isLoginSignup,
  };

  loginClbk = () => window.location.reload();
  employerSignupClbk = () => window.location.reload();
  workerSignupClbk = () => window.location.reload();
}

if (onAffiliatesHiremePage) {
  loginClbk = () => {
    window.location = gotoUrl;
  };
}

if (onContest) {
  loginClbk = () => {
    window.location.reload();
  };

  if (redirectToPcpAfterEmployerSignup) {
    employerSignupClbk = () => {
      _t.push([
        'abtest',
        {
          test: 'RedirectToPcpAfterEmployerSignup',
          variation: 'variation',
        },
      ]);

      window.location.href = '/contest/create.php';
    };
  } else {
    employerSignupClbk = () => {
      _t.push([
        'abtest',
        {
          test: 'RedirectToPcpAfterEmployerSignup',
          variation: 'original',
        },
      ]);

      window.location.reload();
    };
  }

  workerSignupClbk = () => {
    window.location.reload();
  };
}

if (redirectToGotoUrl && gotoUrl) {
  employerSignupClbk = () => {
    window.location = gotoUrl;
  };
  workerSignupClbk = () => {
    window.location = gotoUrl;
  };
  loginOptions.gotoUrl = gotoUrl;
}

// Not always defined
if (projectCollaborationInvitationToken) {
  signupOptions.project_collaboration_invitation_token = projectCollaborationInvitationToken;
  signupOptions.hideFacebook = true;
}

if (contestCollaborationInvitationToken) {
  signupOptions.contest_collaboration_invitation_token = contestCollaborationInvitationToken;
  signupOptions.hideFacebook = true;
}

if (signupSkipFunnel) {
  signupOptions.signup_skip_funnel = signupSkipFunnel;
  signupOptions.gotoUrl = gotoUrl;
}

// Not always defined
if (emailAddress) {
  signupOptions.emailAddress = emailAddress;
}

// Not always defined
if (threadId) {
  signupOptions.thread_id = threadId;
}

// Not always defined
if (eventName) {
  signupOptions.eventName = eventName;
}

const loginSignup = new LoginSignup({
  el: isLoginSignup
    ? $('#login_form_container')
    : $('#default-modal-placeholder'),
  loginClbk,
  employerSignupClbk,
  workerSignupClbk,
  isLocalProject,
  projectId: project_id,
  eventName,
});

$('#login-normal').click(e => {
  e.preventDefault();
  loginSignup.showLogin(loginOptions);
  loginSignup.setBackdrop();
});

$('#sign-up').click(e => {
  e.preventDefault();
  loginSignup.showSignup(signupOptions);
  loginSignup.setBackdrop();
});

if (isLoginSignup) {
  if (showSignup) {
    if (preFillSignupForm) {
      signupOptions.saveFormFields = true;
    }

    loginSignup.showSignup(signupOptions);
  } else {
    loginSignup.showLogin(loginOptions);
  }
}

if (showLogin) {
  $('#login-normal').trigger('click');
}

if (window.performance && window.performance.mark) {
  window.performance.mark('loginsignup_ready');
}
